var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialInstagram = function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.45 19.5h-6.9c-2.25 0-4.05-1.8-4.05-4.05v-6.9C4.5 6.3 6.3 4.5 8.55 4.5h6.85c2.25 0 4.05 1.8 4.05 4.05v6.9c.05 2.25-1.75 4.05-4 4.05M8.55 5.75C7 5.75 5.75 7 5.75 8.55v6.9c0 1.55 1.25 2.8 2.8 2.8h6.85c1.55 0 2.8-1.25 2.8-2.8v-6.9c0-1.55-1.25-2.8-2.8-2.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 15.75c-2.05 0-3.75-1.7-3.75-3.75S9.95 8.25 12 8.25s3.75 1.7 3.75 3.75-1.7 3.75-3.75 3.75m0-6.25c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5M16 7.15c.45 0 .85.4.85.85s-.4.85-.85.85-.85-.4-.85-.85.35-.85.85-.85"
  })));
};
export default SvgSocialInstagram;